var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rd-menubar" }, [
    _c(
      "div",
      { staticClass: "rd-menu-group" },
      [
        _vm._l(_vm.menus, function (menu) {
          return [
            !menu.items
              ? _c(
                  "b-button",
                  {
                    key: menu.id,
                    staticClass: "rd-menu-button",
                    attrs: { variant: "outline-secondary", size: "sm" },
                    on: {
                      click: function ($event) {
                        return _vm.onButtonClick(menu)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(menu.label) + " ")]
                )
              : _c(
                  "b-dropdown",
                  {
                    key: menu.id,
                    staticClass: "rd-menu",
                    attrs: {
                      text: menu.label,
                      variant: "outline-secondary",
                      size: "sm",
                      "menu-class": "rd-menu-list",
                      "toggle-class": "rd-menu-toggle",
                    },
                  },
                  _vm._l(menu.items, function (item) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: item.id,
                        on: {
                          click: function ($event) {
                            return _vm.onSelect(menu, item)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.label) + " ")]
                    )
                  }),
                  1
                ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }